import { ItemId, itemsInfo } from "../../../../json/itemsInfo";
import { getBusinessImage } from "../../../../json/businessImages";
import { getHouseImage } from "../../../../json/housesImages";

export const getVehicleFallback = (model) => {
    return `$https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/${model.toLowerCase()}.png`;
};

export const getPicture = (type, data) => {
    switch(type) {
        case "vehicle":
            if (!data.params || !data.params.model) return null;
            // Основной — majestic, fallback через onerror в шаблоне
            return `https://cdn.just-rp.online/cdn-world.majestic-files.net/public/master/static/img/vehicles/${data.params.model.toLowerCase()}.png`;

        case "business":
            if (!data.params || data.params.id == null) return null;
            return getBusinessImage(data.params.id);

        case "house":
            if (!data.params || data.params.id == null) return null;
            return getHouseImage(data.params.id);

        case "item": {
            if (!data.params) return null;
            const itemInfo = itemsInfo[data.params.itemId];
            if (!itemInfo) return null;
            const icon = itemInfo.Icon;
            if (icon && icon.startsWith('http')) return icon;
            return `${document.cloud}inventoryItems/items/${data.params.itemId}.png`;
        }

        case "clothes": {
            if (!data.params || !data.params.itemData) return null;

            let pngDirectory = "inventoryItems/clothes";
            const dataParse = data.params.itemData.split("_");
            const drawableId = dataParse[0] != undefined ? Number(dataParse[0]) : 0;
            const textureId  = dataParse[1] != undefined ? Number(dataParse[1]) : 0;
            const isMale     = dataParse[2] != undefined && dataParse[2].toLowerCase() === "true";

            pngDirectory += isMale ? "/male" : "/female";

            switch (data.params.itemId) {
                case ItemId.Mask:       pngDirectory += "/masks";       break;
                case ItemId.Glasses:    pngDirectory += "/glasses";     break;
                case ItemId.Ears:       pngDirectory += "/ears";        break;
                case ItemId.Jewelry:    pngDirectory += "/accessories"; break;
                case ItemId.Bracelets:  pngDirectory += "/bracelets";   break;
                case ItemId.Hat:        pngDirectory += "/hats";        break;
                case ItemId.Leg:        pngDirectory += "/legs";        break;
                case ItemId.Feet:       pngDirectory += "/shoes";       break;
                case ItemId.Top:        pngDirectory += "/tops";        break;
                case ItemId.Undershit:  pngDirectory += "/undershit";   break;
                case ItemId.Watches:    pngDirectory += "/watches";     break;
                case ItemId.Bag:        pngDirectory += "/bags";        break;
                case ItemId.Gloves:     pngDirectory += "/gloves";      break;
            }

            pngDirectory += `/${drawableId}_${textureId}`;
            return `${document.cloud}${pngDirectory}.png`;
        }
    }

    return null;
}
